import { Bindable, NotifyProperty, nameof } from "bindable-data";
import { inject, injectable } from "@launchtray/tsyringe-async";
import { INetworkClient } from "../../../../networking/INetworkClient";
import { ILogger } from "by/gamefactory/cityversetycoon/logger/ILogger";
import { IBenefitsModel } from "./IBenefitsModel";
import { BenefitItem } from "./BenefitItem";

@injectable()
export class BenefitsModel extends Bindable implements IBenefitsModel {

    private readonly networkClient: INetworkClient;
    private readonly logger: ILogger;

    public readonly benefits: NotifyProperty<Array<BenefitItem>>;

    public constructor(
        @inject("INetworkClient") networkClient: INetworkClient,
        @inject("ILogger") logger: ILogger
    ) {
        super();
        this.networkClient = networkClient;
        this.logger = logger;
        this.benefits = new NotifyProperty<Array<BenefitItem>>(this, nameof(this, "benefits"), []);

    }

    public async getBenefits(): Promise<void> {
        try {
            const benefits = await this.networkClient.getBenefits();
            this.benefits.setValue(benefits.items.map(item => new BenefitItem(item)) ?? []);
        } catch (error) {
            this.logger.error(error);
        }
    }
}
